import { ActionTypes } from '../actions/Shared';

const initialState = {
  settings: null,
  gunModels: undefined,
  dashboardUseCelsius: null,
};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SETTINGS_SUCCESS:
      return { ...state, settings: action.payload };
    case ActionTypes.UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.payload,
        },
      };
    case ActionTypes.SETTINGS_ERROR:
      return { ...state };
    case ActionTypes.FETCH_GUN_MODELS_SUCCESS:
      return { ...state, gunModels: action.payload };
    case ActionTypes.GUN_MODELS_ERROR:
      return { ...state };
    case ActionTypes.SET_DASHBOARD_USE_CELSIUS:
      return {
        ...state,
        dashboardUseCelsius: action.payload.useCelsius,
      };
    case ActionTypes.SET_DASHBOARD_USE_CELSIUS_ERROR:
      return state;
    default:
      return state;
  }
};

export default SettingsReducer;
